export type Lang = "fr" | "en";

export const t = (lang: Lang, key: string) => {
  const dict = translations[lang] ?? translations.fr;
  return dict[key] ?? key;
};

export const translations: Record<Lang, Record<string, string>> = {
  fr: {
    join_title: "Rejoindre la salle",
    your_name: "Votre nom",
    join: "Joindre",
    leave: "Quitter",
    camera_on: "Allumer la caméra",
    camera_off: "Éteindre la caméra",
    camera_off_status: "Caméra éteinte",
    mic_on: "Allumer le micro",
    mic_off: "Éteindre le micro",
    screenshare_start: "Partager l'écran",
    screenshare_stop: "Arrêter le partage",
    raise_hand: "Lever la main",
    lower_hand: "Baisser la main",
    participants: "Participants",
    settings: "Paramètres",
    camera: "Caméra",
    microphone: "Microphone",
    speaker: "Haut-parleur",
    test_mic: "Tester le micro",
    test_speaker: "Tester le haut-parleur",
    audio_level: "Niveau audio",
    audio_status_silent: "Silencieux",
    audio_status_quiet: "Tranquille",
    audio_status_good: "Bon",
    audio_status_loud: "Fort",
    audio_status_clipping: "Écrêtage",
    hear_mic_contents: "Écouter le contenu du microphone",
    fullscreen: "Plein écran",
    toggle_participants: "Afficher/Masquer la liste",
    cancel: "Annuler",
    save: "Enregistrer",
    help: "Aide",
    join_description: "Configurez vos paramètres avant de rejoindre",
    no_camera_selected: "Aucune caméra sélectionnée",
    camera_preview: "Aperçu de la caméra",
    checking: "Vérification...",
    all: "Tous",
    no_messages: "Aucun message",
    you: "Vous",
    private: "Privé",
    private_message_to: "Message privé à",
    message_to_all: "Message à tous...",
    message_to: "Message",
    quiz_management: "Gestion des Quiz",
    create_quiz: "Créer un Quiz",
    edit_quiz: "Modifier le Quiz",
    delete_quiz: "Supprimer le Quiz",
    quiz_name: "Nom du Quiz",
    quiz_json: "JSON du Quiz",
    save_quiz: "Enregistrer le Quiz",
    preview_quiz: "Aperçu du Quiz",
    start_quiz: "Démarrer le quiz",
    quiz_auto_progressing: "Quiz en cours (mode automatique)",
    start_question: "Démarrer la question",
    stop_question: "Arrêter la question",
    stop_quiz: "Arrêter le quiz",
    next_question: "Question suivante",
    previous_question: "Question précédente",
    question_number: "Question",
    time_remaining: "Temps Restant",
    your_score: "Votre Score",
    correct: "Correct !",
    incorrect: "Incorrect",
    no_answer: "Pas de Réponse",
    quiz_help: "Aide Quiz",
    copy_help: "Copier l'aide",
    quiz_format_description: "Format JSON des Quiz",
    quiz_example: "Exemple de JSON de Quiz",
    quiz_format_help:
      "Chaque quiz est un objet JSON avec un nom et un tableau de questions. Chaque question a un texte de question, un tableau d'options, une correctAnswer (index basé sur 0), et des points.",
    quiz_example_json:
      '{\\"name\\": \\"Quiz Exemple\\", \\"questions\\": [{\\"question\\": \\"Combien fait 2+2 ?\\", \\"options\\": [\\"3\\", \\"4\\", \\"5\\"], \\"correctAnswer\\": 1, \\"points\\": 10}]}',
    select_quiz_to_start: "Sélectionner un Quiz à Démarrer",
    no_quizzes_saved: "Aucun Quiz Sauvegardé",
    create_quiz_first: "Créez d'abord un quiz dans la section de gestion",
    quizzes_available: "quiz disponibles",
    start_selected_quiz: "Démarrer le Quiz Sélectionné",
    default_time: "Temps par défaut",
    go_to_question: "Aller à la question",
    go: "Aller",
    confirm_delete_quiz:
      "Êtes-vous sûr de vouloir supprimer ce quiz ? Cette action ne peut pas être annulée.",
    show_hint: "Afficher l'indice",
    hint: "Indice",
    hint_penalty:
      "Utiliser un indice réduit votre score de 25% pour cette question.",
    camera_device_in_use:
      "La caméra est déjà utilisée par une autre application. Veuillez fermer les autres applications utilisant la caméra et réessayer.",
    microphone_device_in_use:
      "Le microphone est déjà utilisé par une autre application. Veuillez fermer les autres applications utilisant le microphone et réessayer.",
    audio_device_in_use:
      "Le périphérique audio est déjà utilisé par une autre application. Veuillez fermer les autres applications utilisant l'audio et réessayer.",
    media_access_denied:
      "Accès aux médias refusé. Veuillez vérifier les autorisations de caméra et microphone.",
    microphone_permission_denied:
      "Autorisation microphone refusée. Veuillez autoriser l'accès au microphone.",
    camera_permission_denied:
      "Autorisation caméra refusée. Veuillez autoriser l'accès à la caméra.",
    camera_not_found:
      "Aucune caméra détectée. Veuillez vérifier que votre caméra est branchée et réessayer.",
    microphone_not_found:
      "Aucun microphone détecté. Veuillez vérifier que votre microphone est branché et réessayer.",
    device_not_found_title: "Périphérique introuvable",
    device_in_use_title: "Périphérique occupé",
    close_quiz: "Fermer le quiz",
    confirm_close_quiz: "Confirmer la fermeture du quiz",
    confirm_close_quiz_message: "Êtes-vous sûr de vouloir fermer le quiz",
    confirm_quit_quiz: "Confirmer l'arrêt du quiz",
    confirm_quit_quiz_message:
      "Êtes-vous sûr de vouloir arrêter le quiz en cours ?",
    quit_quiz: "Arrêter le quiz",
    quiz_ready: "Quiz Prêt !",
    quiz_contains_questions:
      "Ce quiz contient {count} questions. Préparez-vous à tester vos connaissances !",
    waiting_for_master_to_start:
      "En attente que le professeur démarre le quiz...",
    loading_quiz: "Chargement du Quiz...",
    quiz_loading_description:
      "Synchronisation avec le quiz en cours. Veuillez patienter.",
    waiting_for_master_to_start_question:
      "En attente que le professeur démarre la question...",
    waiting_for_peers: "En attente des participants",
    peers_loading_question: "Les participants chargent la question...",
    question_completed: "Question terminée",
    question_in_progress: "Question en cours",
    congratulations: "Félicitations !",
    better_luck_next_time: "Meilleure chance la prochaine fois !",
    correct_answer: "Bonne réponse",
    master_viewing_mode: "Mode Visualisation Professeur",
    correct_answer_shown: "La bonne réponse est affichée en vert",
    scoring_explanation_title: "Comment les points sont calculés",
    scoring_explanation_base: "Points de base par question : {points}",
    scoring_explanation_hint:
      "Utiliser un indice réduit le score de {percent}%",
    scoring_explanation_first_correct:
      "Premier à répondre correctement : +{percent}% de bonus",
    scoring_explanation_second_correct:
      "Deuxième à répondre correctement : +{percent}% de bonus",
    scoring_explanation_other_correct:
      "Autres réponses correctes : score normal",
    scoring_explanation_incorrect:
      "Réponse incorrecte : -{percent}% des points de base",
    second_screen: "Deuxième Écran",
    second_screen_on: "(Activé)",
    second_screen_off: "(Désactivé)",
    confirm_leave_room: "Confirmer quitter la salle",
    confirm_leave_room_message: "Êtes-vous sûr de vouloir quitter la salle ?",
    recording_will_be_saved_on_leave:
      "L'enregistrement en cours sera automatiquement sauvegardé.",
    network_stats: "Statistiques Réseau",
    network_connection: "Connexion",
    network_quality: "Qualité",
    network_latency: "Latence",
    network_packet_loss: "Perte Paquets",
    network_upload: "Upload",
    network_download: "Download",
    network_video: "Vidéo",
    network_audio: "Audio",
    network_fps: "FPS",
    network_bitrate: "Débit",
    max_participants: "Nombre maximum de participants visibles",
    limited_to: "limité à",
    chat: "Chat",
    start_recording: "Démarrer l'enregistrement",
    stop_recording: "Arrêter l'enregistrement",
    confirm_stop_recording: "Confirmer l'arrêt de l'enregistrement",
    confirm_stop_recording_message:
      "Êtes-vous sûr de vouloir arrêter l'enregistrement ? Cette action ne peut pas être annulée.",
    confirm_close_browser:
      "Êtes-vous certain de vouloir quitter la session de vidéoconférence? Le rapport ne sera pas envoyé",
    confirm_close_browser_with_recording:
      "Êtes-vous certain de vouloir quitter la session de vidéoconférence? Le rapport ne sera pas envoyé et l'enregistrement en cours sera perdu",
    hide_cameras: "Masquer caméras",
    show_cameras: "Afficher caméras",
    teacher_options: "Options professeur",
    // Detailed button tooltips
    tooltip_camera_on: "Cliquez pour éteindre votre caméra",
    tooltip_camera_off: "Cliquez pour allumer votre caméra",
    tooltip_mic_on: "Cliquez pour couper votre microphone",
    tooltip_mic_off: "Cliquez pour activer votre microphone",
    tooltip_screenshare_start:
      "Cliquez pour partager votre écran avec les participants",
    tooltip_screenshare_stop: "Cliquez pour arrêter le partage d'écran",
    tooltip_screenshare_mode_text:
      "Mode netteté : Texte (net, moins fluide). Cliquez pour passer en mode Vidéo",
    tooltip_screenshare_mode_video:
      "Mode netteté : Vidéo (fluide, moins net). Cliquez pour repasser en mode Texte",
    tooltip_screenshare_crop_off:
      "Cliquez pour rogner le partage d'écran en 4:3 (enlève les bandes noires pour tout le monde)",
    tooltip_screenshare_crop_on:
      "Rognage 4:3 activé pour tout le monde. Cliquez pour revenir à l'écran complet",
    tooltip_raise_hand:
      "Cliquez pour lever la main et attirer l'attention du professeur",
    tooltip_lower_hand: "Cliquez pour baisser votre main",
    tooltip_chat: "Cliquez pour ouvrir le panneau de discussion",
    tooltip_network_stats:
      "Cliquez pour afficher les statistiques réseau en temps réel",
    tooltip_start_recording:
      "Cliquez pour démarrer l'enregistrement de la session",
    tooltip_stop_recording: "Cliquez pour arrêter l'enregistrement en cours",
    tooltip_recorder_window:
      "Cliquez pour ouvrir la fenêtre d'enregistrement (à garder ouverte et non minimisée)",
    tooltip_recording_handled_by_recorder:
      "L'enregistrement se pilote depuis la fenêtre dédiée — cliquez pour l'afficher",
    recorder_confirm_stop_title: "Arrêter l'enregistrement ?",
    recorder_confirm_stop_message:
      "L'enregistrement en cours sera finalisé et écrit sur le disque. Cette action ne peut pas être annulée.",
    recorder_confirm_stop_yes: "Arrêter et enregistrer",
    recorder_confirm_stop_no: "Continuer l'enregistrement",
    tooltip_recorder_window_open:
      "Fenêtre d'enregistrement connectée — cliquez pour la ramener au premier plan",
    tooltip_recorder_window_recording:
      "Enregistrement en cours dans la fenêtre dédiée — cliquez pour l'afficher",
    tooltip_local_recording_disabled_recorder_present:
      "L'enregistrement est géré par la fenêtre dédiée",
    tooltip_start_quiz: "Cliquez pour sélectionner et démarrer un quiz",
    tooltip_close_quiz: "Cliquez pour fermer le quiz en cours",
    tooltip_fullscreen: "Cliquez pour passer en mode plein écran",
    tooltip_hide_cameras:
      "Cliquez pour que les participants ne se voient pas les uns les autres",
    tooltip_show_cameras:
      '"Cliquez pour que les participants se voient les uns les autres',
    tooltip_settings: "Cliquez pour ouvrir les paramètres audio et vidéo",
    tooltip_leave: "Cliquez pour quitter la salle de conférence",
    tooltip_join: "Cliquez pour rejoindre la salle de conférence",
    tooltip_participants:
      "Cliquez pour afficher/masquer la liste des participants",
    tooltip_max_participants:
      "Cliquez pour définir le nombre maximum de participants visibles",
    tooltip_teacher_options: "Cliquez pour accéder aux options du professeur",
    tooltip_mute_all:
      "Cliquez pour couper les microphones de tous les participants",
    tooltip_mute_participant:
      "Cliquez pour couper le microphone de ce participant",
    tooltip_unmute_participant:
      "Cliquez pour réactiver le microphone de ce participant",
    tooltip_kick_participant:
      "Cliquez pour expulser ce participant de la session",
    tooltip_master_camera_override_on:
      "Cliquez pour désactiver le mode caméra maître. Votre caméra est actuellement affichée sur l'écran principal de tous les participants, même pendant un partage d'écran ou un quiz.",
    tooltip_master_camera_override_off:
      "Cliquez pour activer le mode caméra maître. Votre caméra sera affichée sur l'écran principal de tous les participants, remplaçant le partage d'écran et les quiz.",
    tooltip_feedback_control_on:
      "Contrôle de feedback actif : cliquez pour revenir au micro normal.",
    tooltip_feedback_control_off:
      "Active le traitement WebRTC du micro quand d'autres micros sont ouverts.",
    feedback_control_active:
      "Contrôle de feedback actif - éteindre quand les autres micros sont fermés",
    peer_visibility: "Visibilité des participants",
    virtual_background: "Fond d'écran virtuel",
    background_none: "Aucun",
    background_blur: "Flou",
    background_blur_strong: "Flou intense",
    background_office: "Bureau",
    background_library: "Bibliothèque",
    background_nature: "Nature",
    background_beach: "Plage",
    background_mountains: "Montagnes",
    background_city: "Ville",
    background_abstract: "Abstrait",
    background_gradient: "Dégradé",
    insert_demo_quizzes: "Insérer des quiz de démonstration",
    demo_quizzes: "Quiz de démo",
    send_to: "Envoyer à",
    all_participants: "Tous",
    no_messages_yet: "Aucun message",
    you_label: "Vous",
    private_label: "Privé",
    master_label: "Professeur",
    message_to_all_placeholder: "Message à tous...",
    message_to_teacher_placeholder: "Message",
    interactive_mode: "Mode Interactif",
    presentation_mode: "Mode Présentation",
    question_preparation: "Préparation de la question",
    question_coming: "La question arrive...",
    presentation_mode_manual: "Mode présentation - Navigation manuelle",
    explanation_label: "Explication",
    points: "Points",
    hand_raised: "Main levée",
    speaking_now: "En train de parler",
    error_control_mic: "Impossible de contrôler le micro du participant",
    confirm_kick_title: "Confirmer l'expulsion",
    confirm_kick_message:
      "Voulez-vous vraiment expulser {name} de la session ?",
    error_kick_participant: "Impossible d'expulser le participant",
    noise_cancellation: "Réduction du bruit",
    mic_audio_delay: "Délai audio micro (ms)",
    tooltip_mic_audio_delay:
      "Ajoute un délai au micro pour synchroniser avec la caméra. Chaque caméra peut avoir son propre délai. Utile quand la caméra et le micro proviennent de sources différentes.",
    allow_peer_visibility_startup:
      "Autoriser les participants à se voir mutuellement au démarrage",
    screenshare_settings: "Partage d'écran",
    allow_participant_screenshare: "Autoriser les participants à partager leur écran",
    tooltip_allow_participant_screenshare:
      "Par défaut, seul le maître peut partager son écran. Cochez pour permettre aussi aux participants de le faire.",
    screenshare_default_crop: "Rognage 4:3 activé par défaut",
    tooltip_screenshare_default_crop:
      "Active par défaut le rognage 4:3 pour éliminer les bandes noires lors du partage d'écran.",
    screenshare_default_mode: "Mode de netteté par défaut",
    tooltip_screenshare_default_mode:
      "Définit le profil d'encodage par défaut lors du démarrage du partage d'écran.",
    screenshare_mode_video_option: "Vidéo (fluide, 30 fps)",
    screenshare_mode_text_option: "Texte (haute précision, 8 fps)",
    recording_settings: "Paramètres d'enregistrement",
    auto_record_on_start: "Enregistrement automatique au démarrage",
    width_px: "Largeur (px)",
    height_px: "Hauteur (px)",
    master_camera_width_px: "Largeur min. caméra maître (px)",
    // Settings tooltips
    tooltip_noise_cancellation:
      "Active la réduction du bruit pour améliorer la qualité audio en supprimant les bruits de fond",
    tooltip_allow_peer_visibility:
      "Les participants peuvent se voir lors de leur arrivée. Désactiver masque les caméras par défaut.",
    tooltip_auto_record:
      "L'enregistrement commence automatiquement quand vous accédez à la salle",
    tooltip_master_video_width:
      "La largeur minimale de votre caméra lors de l'enregistrement avec partage d'écran ou quiz. Si le contenu partagé laisse de l'espace horizontal libre, la caméra s'agrandit automatiquement.",
    tooltip_master_video_height:
      "La hauteur de votre caméra lors de l'enregistrement avec partage d'écran ou quiz",
    video_codec: "Codec vidéo",
    video_quality: "Qualité vidéo",
    quality_low: "Basse",
    quality_medium: "Moyenne",
    quality_high: "Haute",
    quality_very_high: "Très haute",
    enter_name: "Entrez votre nom",
    panel_left: "Gauche",
    panel_right: "Droite",
    panel_top: "Haut",
    panel_bottom: "Bas",
    panel_position: "Position du panneau",
    a_participant: "un participant",
    // Compatibility errors
    compat_webrtc: "WebRTC n'est pas pris en charge dans ce navigateur",
    compat_mediadevices:
      "L'accès à la caméra et au microphone n'est pas pris en charge",
    compat_audiocontext:
      "La visualisation audio peut ne pas fonctionner correctement",
    compat_serviceworker:
      "Les fonctionnalités hors ligne ne sont pas disponibles",
    compat_https: "HTTPS est requis pour l'accès à la caméra et au microphone",
    compat_safari11: "Safari 11 ou plus récent est requis",
    compat_screensize:
      "La taille de l'écran est très petite, certaines fonctionnalités peuvent ne pas s'afficher correctement",
    compat_performance:
      "Les performances de l'appareil peuvent être limitées, la qualité vidéo sera réduite",
    compat_touchdesktop:
      "Bureau tactile détecté, certaines interactions peuvent différer",
    audio_suspended_title: "Audio suspendu",
    audio_suspended_message: "Appuyez pour reprendre l'audio",
    fullscreen_not_supported: "Le plein écran n'est pas disponible",
    fullscreen_install_app:
      "Veuillez installer l'application pour utiliser le plein écran",
    tap_for_fullscreen: "Toucher pour le plein écran",
    // Mobile app installation prompts
    install_app_title: "Installer l'application",
    install_app_prompt: "Installez l'application pour une meilleure expérience",
    install_app_button: "Installer",
    install_app_dismiss: "Plus tard",
    install_help_title: "Comment installer sur iOS/Android",
    install_help_ios:
      "Sur iOS: Appuyez sur Partager et sélectionnez \"Sur l'écran d'accueil\"",
    install_help_android:
      'Sur Android: Appuyez sur le menu ⋮ et sélectionnez "Installer l\'application"',
    install_help_description:
      "L'installation de l'application vous permet d'accéder plus rapidement et d'avoir une meilleure expérience hors ligne.",
    missing_room_code:
      "Le paramètre roomCode est manquant dans l'URL. Format attendu : roomCode=sous-domaine.salle (ex: cate.Normal)",
    invalid_room_code_format:
      "Le paramètre roomCode est invalide. Il doit contenir deux parties séparées par un point : sous-domaine.salle (ex: cate.Normal)",
    failed_to_join_room:
      "Impossible de rejoindre la salle. Veuillez vérifier le code de la salle et réessayer.",
    failed_to_generate_token:
      "Impossible de générer le jeton d'authentification. Veuillez vérifier vos identifiants.",
    room_not_found_create:
      "La salle \"{room}\" n'existe pas sur Daily.co. Voulez-vous la créer ?",
    room_creation_cancelled:
      "Création de la salle annulée.",
    create_room: "Créer la salle",
    failed_to_create_room:
      "Impossible de créer la salle. Veuillez vérifier votre clé API.",
    invalid_master_credential:
      "Votre clé d'accès a été refusée. Vérifiez le lien du maître (paramètre key ou m) et le sous-domaine du roomCode.",
    mute_all_participants_success: "participant(s) ont été coupés.",
    mute_all_participants_failed:
      "échec(s). Vérifiez que vous avez les permissions nécessaires.",
    failed_apply_camera_settings:
      "Impossible d'appliquer les paramètres de caméra ou microphone. Veuillez réessayer.",
    failed_apply_speaker_settings:
      "Impossible d'appliquer les paramètres du haut-parleur. Veuillez réessayer.",
    calculating_statistics: "Calcul des statistiques",
    daily_call_not_initialized: "L'objet appel Daily n'est pas initialisé",
    microphone_permission_denied_join:
      "Autorisation microphone refusée. Veuillez autoriser l'accès au microphone pour rejoindre l'appel.",
    camera_permission_denied_join:
      "Autorisation caméra refusée. Veuillez autoriser l'accès à la caméra pour rejoindre l'appel.",
    failed_get_media_stream: "Impossible d'obtenir le flux médias",
    video_element_not_available: "Élément vidéo non disponible",
    failed_get_audio_stream: "Impossible d'obtenir le flux audio",
    invalid_quiz_structure: "Structure de quiz invalide",
    invalid_question_structure: "Structure de question invalide",
    invalid_option_structure:
      "Structure d'option invalide - chaque option doit avoir une propriété texte",
    failed_capture_canvas_stream:
      "Impossible de capturer le flux canvas ou aucune piste vidéo disponible",
    combined_stream_no_tracks: "Le flux combiné n'a pas de pistes",
    no_supported_mime_type:
      "Aucun type MIME pris en charge trouvé pour MediaRecorder",
    quiz_mode: "MODE QUIZ",
    quiz_fallback_recording:
      "(Enregistrement de secours - capture complète du quiz indisponible)",
    quiz_active_recording: "Quiz Actif - Enregistrement",
    content_loading: "(Chargement du contenu...)",
    quiz_active_waiting: "Quiz Actif - En attente du contenu",
    preparing_quiz_recording: "(Préparation de l'enregistrement du quiz...)",
    participant_camera_off: "📹 La caméra de {participant} est éteinte",
    showing_master_instead: "Affichage de la caméra maître à la place",
    no_video_available: "Aucune vidéo disponible à enregistrer",
    only_master_can_record: "Seul le maître peut enregistrer",
    starting_recording: "Démarrage de l'enregistrement...",
    canvas_created_main_thread:
      "Canvas créé et sera dessiné sur le thread principal",
    failed_create_canvas:
      "Échec de la création du canvas d'enregistrement ou de la capture du flux",
    initial_audio_setup: "Configuration audio initiale",
    using_mime_type: "Utilisation du type MIME : {mimeType}",
    media_recorder_created: "MediaRecorder créé avec succès",
    recording_stopped_saving: "Enregistrement arrêté, sauvegarde du fichier...",
    chunks_collected: "Fragments collectés : {count}",
    no_recorded_data: "Aucune donnée enregistrée disponible",
    recorded_blob_empty: "Le blob enregistré est vide",
    file_saved: "Fichier enregistré sous : {filename} ({size} MB)",
    recording_started_success: "Enregistrement démarré avec succès",
    failed_start_recording: "Échec du démarrage de l'enregistrement",
    recording_already_stopped: "Enregistrement déjà arrêté",
    stopping_recording: "Arrêt de l'enregistrement...",
    notified_worker_stop: "Worker notifié pour arrêter",
    requesting_final_chunks: "Demande des derniers fragments de données...",
    stopping_media_recorder: "Arrêt du MediaRecorder...",
    stopping_original_streams: "Arrêt des flux audio de qualité originale",
    original_streams_cleaned: "Flux de qualité originale nettoyés",
    recording_stopped_success: "Enregistrement arrêté avec succès",
    error_stopping_recording: "Erreur lors de l'arrêt de l'enregistrement",
    auto_starting_recording: "Démarrage automatique de l'enregistrement...",
    component_unmounting_stopping:
      "Composant en cours de démontage, arrêt de l'enregistrement...",
    failed_open_quiz_iframe:
      "Échec de l'ouverture de l'iframe du quiz d'enregistrement",
    quiz_iframe_window_not_accessible:
      "La fenêtre de l'iframe du quiz n'est pas accessible",
    sent_quiz_data_to_iframe: "Données du quiz envoyées à l'iframe",
    max_recreation_attempts_reached:
      "Nombre maximal de tentatives de recréation atteint",
    attempting_recreate_iframe:
      "Tentative de recréation de l'iframe (tentative {attempt}/{max})",
    successfully_recreated_iframe:
      "Iframe du quiz d'enregistrement recréé avec succès",
    received_ready_signal: "Signal prêt reçu de l'iframe du quiz",
    fallback_timer_started:
      "Démarrage du minuteur de secours de 10 secondes pour l'iframe prêt",
    no_ready_signal_assuming_ready:
      "Aucun signal prêt reçu après 10s, supposant que l'iframe est prêt",
    pwa_install_prompt_title: "Installer l'application",
    pwa_install_prompt_message:
      "Installer cette application sur votre appareil pour un meilleur accès",
    pwa_install_button: "Installer maintenant",
    pwa_dismiss_button: "Plus tard",
    pwa_already_installed: "L'application est déjà installée",
    install_help_detected_ios:
      "Votre appareil a détecté iOS. Voici les instructions spécifiques :",
    install_help_detected_android:
      "Votre appareil a détecté Android. Voici les instructions spécifiques :",
    install_help_general_instructions: "Instructions générales",
    install_help_access_from_phone:
      "Accédez à ce site avec votre téléphone iOS ou Android pour voir les instructions spécifiques.",
    install_help_benefits_title: "Avantages de l'installation :",
    install_help_benefit_quick_access:
      "✓ Accès rapide depuis l'écran d'accueil",
    install_help_benefit_performance: "✓ Meilleure performance",
    install_help_benefit_offline: "✓ Fonctionnement hors ligne",
    install_help_benefit_fullscreen: "✓ Interface plein écran",
    install_help_ios_step1: "1. Ouvrez Safari et naviguez vers l'application",
    install_help_ios_step2:
      "2. Appuyez sur le bouton Partager (carré avec flèche)",
    install_help_ios_step3: "3. Sélectionnez \"Sur l'écran d'accueil\"",
    install_help_ios_step4:
      '4. Entrez le nom de l\'application et appuyez sur "Ajouter"',
    install_help_android_step1:
      "1. Ouvrez Chrome et naviguez vers l'application",
    install_help_android_step2:
      "2. Appuyez sur le menu (trois points) en haut à droite",
    install_help_android_step3: '3. Sélectionnez "Installer l\'application"',
    install_help_android_step4: '4. Confirmez en appuyant sur "Installer"',
    check_for_updates: "Vérifier les mises à jour",
    long_response_warning_title: "Attention : Réponse(s) trop longue(s)",
    long_response_warning_message: "Les réponses suivantes dépassent 50 caractères et risquent d'être tronquées à l'affichage :",
    long_response_warning_question: "Voulez-vous enregistrer le quiz quand même ?",
    save_anyway: "Enregistrer quand même",
    characters: "caractères",
    usage_statistics: "Statistiques d'utilisation",
    recompute_minutes: "Recalculer le total mensuel",
    tooltip_recompute_minutes: "Force un nouveau calcul complet depuis l'API Daily.co et met à jour la valeur mémorisée utilisée dans le prochain rapport.",
    recompute_minutes_cached: "Valeur mémorisée : {minutes} min.",
    recompute_minutes_result: "✓ {minutes} minutes ce mois (mis à jour)",
    recompute_minutes_error: "✗ Échec – vérifiez la clé API",
    floor_too_many_speakers: "Plusieurs élèves parlent déjà. Levez la main pour demander la parole.",
    floor_granted: "La parole vous est accordée.",
    floor_denied_by_master: "Le micro n'est pas autorisé actuellement.",
    floor_revoked_by_master: "Le maître a coupé votre micro.",
    floor_timeout: "Délai d'attente dépassé pour l'activation du micro.",
    give_floor: "Donner la parole",
    revoke_floor: "Couper la parole",
    speaking_allowed: "Parole autorisée",
    listening_only: "Écoute seule",
  },
  en: {
    join_title: "Join Room",
    your_name: "Your name",
    join: "Join",
    leave: "Leave",
    camera_on: "Turn camera on",
    camera_off: "Turn camera off",
    camera_off_status: "Camera off",
    mic_on: "Unmute mic",
    mic_off: "Mute mic",
    screenshare_start: "Share screen",
    screenshare_stop: "Stop sharing",
    raise_hand: "Raise hand",
    lower_hand: "Lower hand",
    participants: "Participants",
    settings: "Settings",
    camera: "Camera",
    microphone: "Microphone",
    speaker: "Speaker",
    test_mic: "Test mic",
    test_speaker: "Test speaker",
    audio_level: "Audio Level",
    audio_status_silent: "Silent",
    audio_status_quiet: "Quiet",
    audio_status_good: "Good",
    audio_status_loud: "Loud",
    audio_status_clipping: "Clipping",
    hear_mic_contents: "Hear mic contents",
    fullscreen: "Full screen",
    toggle_participants: "Toggle list",
    cancel: "Cancel",
    save: "Save",
    help: "Help",
    join_description: "Configure your settings before joining",
    no_camera_selected: "No camera selected",
    camera_preview: "Camera preview",
    checking: "Checking...",
    all: "All",
    no_messages: "No messages",
    you: "You",
    private: "Private",
    private_message_to: "Private message to",
    message_to_all: "Message to all...",
    message_to: "Message",
    quiz_management: "Quiz Management",
    create_quiz: "Create Quiz",
    edit_quiz: "Edit Quiz",
    delete_quiz: "Delete Quiz",
    quiz_name: "Quiz Name",
    quiz_json: "Quiz JSON",
    save_quiz: "Save Quiz",
    preview_quiz: "Preview Quiz",
    start_quiz: "Start quiz",
    start_question: "Start question",
    stop_question: "Stop question",
    stop_quiz: "Stop quiz",
    next_question: "Next question",
    previous_question: "Previous question",
    question_number: "Question",
    time_remaining: "Time Remaining",
    your_score: "Your Score",
    correct: "Correct!",
    incorrect: "Incorrect",
    no_answer: "No Answer",
    quiz_help: "Quiz Help",
    copy_help: "Copy Help",
    quiz_format_description: "Quiz JSON Format",
    quiz_example: "Example Quiz JSON",
    quiz_format_help:
      "Each quiz is a JSON object with name and questions array. Each question has question text, options array, correctAnswer (0-based index), and points.",
    quiz_example_json:
      '{\\"name\\": \\"Sample Quiz\\", \\"questions\\": [{\\"question\\": \\"What is 2+2?\\", \\"options\\": [\\"3\\", \\"4\\", \\"5\\"], \\"correctAnswer\\": 1, \\"points\\": 10}]}',
    select_quiz_to_start: "Select Quiz to Start",
    no_quizzes_saved: "No Quizzes Saved",
    create_quiz_first: "Create a quiz first in the management section",
    quizzes_available: "quizzes available",
    start_selected_quiz: "Start Selected Quiz",
    default_time: "Default time",
    go_to_question: "Go to question",
    go: "Go",
    confirm_delete_quiz:
      "Are you sure you want to delete this quiz? This action cannot be undone.",
    show_hint: "Show hint",
    hint: "Hint",
    hint_penalty: "Using a hint reduces your score by 25% for this question.",
    camera_device_in_use:
      "Camera device is already in use by another application. Please close other applications using the camera and try again.",
    microphone_device_in_use:
      "Microphone device is already in use by another application. Please close other applications using the microphone and try again.",
    audio_device_in_use:
      "Audio output device is already in use by another application. Please close other applications using audio and try again.",
    media_access_denied:
      "Media access denied. Please check your camera and microphone permissions.",
    microphone_permission_denied:
      "Microphone permission denied. Please allow microphone access.",
    camera_permission_denied:
      "Camera permission denied. Please allow camera access.",
    camera_not_found:
      "No camera detected. Please check that your camera is connected and try again.",
    microphone_not_found:
      "No microphone detected. Please check that your microphone is connected and try again.",
    device_not_found_title: "Device not found",
    device_in_use_title: "Device in use",
    close_quiz: "Close Quiz",
    confirm_close_quiz: "Confirm Quiz Closure",
    confirm_close_quiz_message: "Are you sure you want to close the quiz",
    confirm_quit_quiz: "Confirm Quiz Stop",
    confirm_quit_quiz_message:
      "Are you sure you want to stop the current quiz?",
    quit_quiz: "Stop Quiz",
    quiz_ready: "Quiz Ready!",
    quiz_contains_questions:
      "This quiz contains {count} questions. Get ready to test your knowledge!",
    waiting_for_master_to_start: "Waiting for the teacher to start the quiz...",
    loading_quiz: "Loading Quiz...",
    quiz_loading_description:
      "Synchronizing with the ongoing quiz. Please wait.",
    waiting_for_master_to_start_question:
      "Waiting for the teacher to start the question...",
    waiting_for_peers: "Waiting for participants",
    peers_loading_question: "Participants are loading the question...",
    question_completed: "Question Completed",
    question_in_progress: "Question in Progress",
    congratulations: "Congratulations!",
    better_luck_next_time: "Better luck next time!",
    correct_answer: "Correct Answer",
    master_viewing_mode: "Teacher Viewing Mode",
    correct_answer_shown: "The correct answer is shown in green",
    scoring_explanation_title: "How Points Are Calculated",
    scoring_explanation_base: "Base points per question: {points}",
    scoring_explanation_hint: "Using a hint reduces score by {percent}%",
    scoring_explanation_first_correct:
      "First to answer correctly: +{percent}% bonus",
    scoring_explanation_second_correct:
      "Second to answer correctly: +{percent}% bonus",
    scoring_explanation_other_correct: "Other correct answers: normal score",
    scoring_explanation_incorrect:
      "Incorrect answer: -{percent}% of base points",
    second_screen: "Second Screen",
    second_screen_on: "(On)",
    second_screen_off: "(Off)",
    confirm_leave_room: "Confirm Leave Room",
    confirm_leave_room_message: "Are you sure you want to leave the room?",
    recording_will_be_saved_on_leave:
      "The current recording will be automatically saved.",
    network_stats: "Network Stats",
    network_connection: "Connection",
    network_quality: "Quality",
    network_latency: "Latency",
    network_packet_loss: "Packet Loss",
    network_upload: "Upload",
    network_download: "Download",
    network_video: "Video",
    network_audio: "Audio",
    network_fps: "FPS",
    network_bitrate: "Bitrate",
    max_participants: "Maximum participants",
    limited_to: "limited to",
    chat: "Chat",
    start_recording: "Start recording",
    stop_recording: "Stop recording",
    confirm_stop_recording: "Confirm stop recording",
    confirm_stop_recording_message:
      "Are you sure you want to stop the recording? This action cannot be undone.",
    confirm_close_browser:
      "Are you sure you want to leave the videoconference session? The report will not be sent",
    confirm_close_browser_with_recording:
      "Are you sure you want to leave the videoconference session? The report will not be sent and the ongoing recording will be lost",
    hide_cameras: "Hide cameras",
    show_cameras: "Show cameras",
    teacher_options: "Teacher options",
    // Detailed button tooltips
    tooltip_camera_on: "Click to turn off your camera",
    tooltip_camera_off: "Click to turn on your camera",
    tooltip_mic_on: "Click to mute your microphone",
    tooltip_mic_off: "Click to unmute your microphone",
    tooltip_screenshare_start: "Click to share your screen with participants",
    tooltip_screenshare_stop: "Click to stop screen sharing",
    tooltip_screenshare_mode_text:
      "Sharpness mode: Text (crisp, less smooth). Click to switch to Video mode",
    tooltip_screenshare_mode_video:
      "Sharpness mode: Video (smooth, less crisp). Click to switch back to Text mode",
    tooltip_screenshare_crop_off:
      "Click to crop the screen share to 4:3 (removes the black bars for everyone)",
    tooltip_screenshare_crop_on:
      "4:3 crop is on for everyone. Click to go back to the full screen",
    tooltip_raise_hand:
      "Click to raise your hand and get the teacher's attention",
    tooltip_lower_hand: "Click to lower your hand",
    tooltip_chat: "Click to open the chat panel",
    tooltip_network_stats: "Click to display real-time network statistics",
    tooltip_start_recording: "Click to start recording the session",
    tooltip_stop_recording: "Click to stop the current recording",
    tooltip_recorder_window:
      "Click to open the recorder window (keep it open and not minimised)",
    tooltip_recording_handled_by_recorder:
      "Recording is controlled from the dedicated window — click to show it",
    recorder_confirm_stop_title: "Stop the recording?",
    recorder_confirm_stop_message:
      "The current recording will be finalised and written to disk. This cannot be undone.",
    recorder_confirm_stop_yes: "Stop and save",
    recorder_confirm_stop_no: "Keep recording",
    tooltip_recorder_window_open:
      "Recorder window connected — click to bring it to the front",
    tooltip_recorder_window_recording:
      "Recording in the dedicated window — click to show it",
    tooltip_local_recording_disabled_recorder_present:
      "Recording is handled by the dedicated recorder window",
    tooltip_start_quiz: "Click to select and start a quiz",
    tooltip_close_quiz: "Click to close the current quiz",
    tooltip_fullscreen: "Click to enter fullscreen mode",
    tooltip_hide_cameras:
      "Click to prevent participants from seeing each other",
    tooltip_show_cameras: "Click for participants to see each other",
    tooltip_settings: "Click to open audio and video settings",
    tooltip_leave: "Click to leave the conference room",
    tooltip_join: "Click to join the conference room",
    tooltip_participants: "Click to show/hide the participant list",
    tooltip_max_participants:
      "Click to set the maximum number of visible participants",
    tooltip_teacher_options: "Click to access teacher options",
    tooltip_mute_all: "Click to mute all participant microphones",
    tooltip_mute_participant: "Click to mute this participant's microphone",
    tooltip_unmute_participant: "Click to unmute this participant's microphone",
    tooltip_kick_participant:
      "Click to remove this participant from the session",
    tooltip_master_camera_override_on:
      "Click to disable master camera mode. Your camera is currently displayed on all participants' main screen, even during screen sharing or quizzes.",
    tooltip_master_camera_override_off:
      "Click to enable master camera mode. Your camera will be displayed on all participants' main screen, overriding screen sharing and quizzes.",
    tooltip_feedback_control_on:
      "Feedback Control is active. Click to return to the normal mic.",
    tooltip_feedback_control_off:
      "Enable WebRTC mic processing when other microphones are open.",
    feedback_control_active:
      "Feedback Control active - turn off when other mics are closed",
    peer_visibility: "Participant Visibility",
    virtual_background: "Virtual Background",
    background_none: "None",
    background_blur: "Blur",
    background_blur_strong: "Strong Blur",
    background_office: "Office",
    background_library: "Library",
    background_nature: "Nature",
    background_beach: "Beach",
    background_mountains: "Mountains",
    background_city: "City",
    background_abstract: "Abstract",
    background_gradient: "Gradient",
    insert_demo_quizzes: "Insert demo quizzes",
    demo_quizzes: "Demo quizzes",
    send_to: "Send to",
    all_participants: "All",
    no_messages_yet: "No messages",
    you_label: "You",
    private_label: "Private",
    master_label: "Teacher",
    private_message_placeholder: "Private message to",
    message_to_all_placeholder: "Message to all...",
    message_to_teacher_placeholder: "Message",
    interactive_mode: "Interactive Mode",
    presentation_mode: "Presentation Mode",
    question_preparation: "Preparing question",
    question_coming: "Question coming...",
    presentation_mode_manual: "Presentation mode - Manual navigation",
    explanation_label: "Explanation",
    points: "Points",
    hand_raised: "Hand raised",
    speaking_now: "Speaking now",
    error_control_mic: "Unable to control participant microphone",
    confirm_kick_title: "Confirm Kick",
    confirm_kick_message: "Do you really want to kick {name} from the session?",
    error_kick_participant: "Unable to kick participant",
    noise_cancellation: "Noise cancellation",
    mic_audio_delay: "Mic audio delay (ms)",
    tooltip_mic_audio_delay:
      "Adds a delay to the microphone to sync with the camera. Each camera can have its own delay. Useful when camera and mic come from different sources.",
    allow_peer_visibility_startup:
      "Allow participants to see each other on startup",
    screenshare_settings: "Screen sharing",
    allow_participant_screenshare: "Allow participants to share their screen",
    tooltip_allow_participant_screenshare:
      "By default, only the master can share their screen. Check to let participants share theirs too.",
    screenshare_default_crop: "4:3 crop enabled by default",
    tooltip_screenshare_default_crop:
      "Enables 4:3 crop by default to remove black bars during screen sharing.",
    screenshare_default_mode: "Default sharpness mode",
    tooltip_screenshare_default_mode:
      "Sets the default encoding profile when starting screen share.",
    screenshare_mode_video_option: "Video (smooth, 30 fps)",
    screenshare_mode_text_option: "Text (high sharpness, 8 fps)",
    recording_settings: "Recording Settings",
    auto_record_on_start: "Automatic recording on start",
    width_px: "Width (px)",
    height_px: "Height (px)",
    master_camera_width_px: "Min. master camera width (px)",
    // Settings tooltips
    tooltip_noise_cancellation:
      "Enables noise cancellation to improve audio quality by suppressing background noise",
    tooltip_allow_peer_visibility:
      "Participants can see each other when they join. Disable to hide cameras by default.",
    tooltip_auto_record:
      "Recording starts automatically when you enter the room",
    tooltip_master_video_width:
      "The minimum width of your camera when recording with screen sharing or quiz. If the shared content leaves horizontal space, the camera expands automatically.",
    tooltip_master_video_height:
      "The height of your camera when recording with screen sharing or quiz",
    video_codec: "Video codec",
    video_quality: "Video quality",
    quality_low: "Low",
    quality_medium: "Medium",
    quality_high: "High",
    quality_very_high: "Very High",
    enter_name: "Enter your name",
    panel_left: "Left",
    panel_right: "Right",
    panel_top: "Top",
    panel_bottom: "Bottom",
    panel_position: "Panel position",
    // Compatibility errors
    compat_webrtc: "WebRTC is not supported in this browser",
    compat_mediadevices: "Camera and microphone access is not supported",
    compat_audiocontext: "Audio visualization may not work properly",
    compat_serviceworker: "Offline functionality is not available",
    compat_https: "HTTPS is required for camera and microphone access",
    compat_safari11: "Safari 11 or newer is required",
    compat_screensize:
      "Screen size is very small, some features may not display properly",
    compat_performance:
      "Device performance may be limited, video quality will be reduced",
    compat_touchdesktop:
      "Touch-enabled desktop detected, some interactions may differ",
    audio_suspended_title: "Audio paused",
    audio_suspended_message: "Tap to resume audio",
    fullscreen_not_supported: "Fullscreen is not available",
    fullscreen_install_app: "Please install the app to use fullscreen",
    tap_for_fullscreen: "Tap for fullscreen",
    // Mobile app installation prompts
    install_app_title: "Install App",
    install_app_prompt: "Install the app for a better experience",
    install_app_button: "Install",
    install_app_dismiss: "Later",
    install_help_title: "How to Install on iOS/Android",
    install_help_ios: 'On iOS: Tap Share and select "Add to Home Screen"',
    install_help_android: 'On Android: Tap the menu ⋮ and select "Install app"',
    install_help_description:
      "Installing the app lets you access faster and get a better offline experience.",
    missing_room_code:
      "The roomCode parameter is missing from the URL. Expected format: roomCode=subdomain.room (e.g., cate.Normal)",
    invalid_room_code_format:
      "The roomCode parameter is invalid. It must contain two parts separated by a dot: subdomain.room (e.g., cate.Normal)",
    failed_to_join_room:
      "Failed to join room. Please check the room code and try again.",
    create_room: "Create room",
    failed_to_generate_token:
      "Failed to apply speaker settings. Please try again.",
    // These three were missing: t() falls back to the raw key, not to French,
    // so an English master was shown "room_not_found_create" verbatim.
    room_not_found_create:
      "Room \"{room}\" does not exist on Daily.co. Do you want to create it?",
    room_creation_cancelled:
      "Room creation cancelled.",
    failed_to_create_room:
      "Failed to create the room. Please check your API key.",
    invalid_master_credential:
      "Your access key was refused. Check the master link (key or m parameter) and the roomCode subdomain.",
    calculating_statistics: "Calculating statistics",
    daily_call_not_initialized: "Daily call object not initialized",
    microphone_permission_denied_join:
      "Microphone permission denied. Please allow microphone access to join the call.",
    camera_permission_denied_join:
      "Camera permission denied. Please allow camera access to join the call.",
    failed_get_media_stream: "Failed to get media stream",
    video_element_not_available: "Video element not available",
    failed_get_audio_stream: "Failed to get audio stream",
    invalid_quiz_structure: "Invalid quiz structure",
    invalid_question_structure: "Invalid question structure",
    invalid_option_structure:
      "Invalid option structure - each option must have a text property",
    failed_capture_canvas_stream:
      "Failed to capture canvas stream or no video tracks available",
    combined_stream_no_tracks: "Combined stream has no tracks",
    no_supported_mime_type: "No supported mime type found for MediaRecorder",
    quiz_mode: "QUIZ MODE",
    quiz_fallback_recording:
      "(Recording fallback - full quiz capture unavailable)",
    quiz_active_recording: "Quiz Active - Recording",
    content_loading: "(Content loading...)",
    quiz_active_waiting: "Quiz Active - Waiting for Content",
    preparing_quiz_recording: "(Preparing quiz recording...)",
    participant_camera_off: "📹 {participant}'s camera is off",
    showing_master_instead: "Showing master camera instead",
    no_video_available: "No video available to record",
    only_master_can_record: "Only master can record",
    starting_recording: "Starting recording...",
    canvas_created_main_thread:
      "Canvas created and will be drawn on main thread",
    failed_create_canvas: "Failed to create recording canvas or capture stream",
    initial_audio_setup: "Initial audio setup",
    using_mime_type: "Using mime type: {mimeType}",
    media_recorder_created: "MediaRecorder created successfully",
    recording_stopped_saving: "Recording stopped, saving file...",
    chunks_collected: "Chunks collected: {count}",
    no_recorded_data: "No recorded data available",
    recorded_blob_empty: "Recorded blob is empty",
    file_saved: "File saved as: {filename} ({size} MB)",
    recording_started_success: "Recording started successfully",
    failed_start_recording: "Failed to start recording",
    recording_already_stopped: "Recording already stopped",
    stopping_recording: "Stopping recording...",
    notified_worker_stop: "Notified worker to stop",
    requesting_final_chunks: "Requesting final data chunks...",
    stopping_media_recorder: "Stopping MediaRecorder...",
    stopping_original_streams: "Stopping original quality audio streams",
    original_streams_cleaned: "Original quality streams cleaned up",
    recording_stopped_success: "Recording stopped successfully",
    error_stopping_recording: "Error stopping recording",
    auto_starting_recording: "Auto-starting recording...",
    component_unmounting_stopping:
      "Component unmounting, stopping recording...",
    failed_open_quiz_iframe: "Failed to open recording quiz iframe",
    quiz_iframe_window_not_accessible: "Quiz iframe window not accessible",
    sent_quiz_data_to_iframe: "Sent quiz data to iframe",
    max_recreation_attempts_reached: "Max recreation attempts reached",
    attempting_recreate_iframe:
      "Attempting to recreate iframe (attempt {attempt}/{max})",
    successfully_recreated_iframe:
      "Successfully recreated recording quiz iframe",
    received_ready_signal: "Received ready signal from quiz iframe",
    fallback_timer_started:
      "Starting 10-second fallback timer for iframe ready",
    no_ready_signal_assuming_ready:
      "No ready signal received after 10s, assuming iframe is ready",
    pwa_install_prompt_title: "Install App",
    pwa_install_prompt_message:
      "Install this app on your device for better access",
    pwa_install_button: "Install Now",
    pwa_dismiss_button: "Later",
    pwa_already_installed: "App is already installed",
    install_help_detected_ios:
      "Your device detected iOS. Here are the specific instructions:",
    install_help_detected_android:
      "Your device detected Android. Here are the specific instructions:",
    install_help_general_instructions: "General Instructions",
    install_help_access_from_phone:
      "Access this site from your iOS or Android phone to see device-specific instructions.",
    install_help_benefits_title: "Benefits of installing:",
    install_help_benefit_quick_access: "✓ Quick access from home screen",
    install_help_benefit_performance: "✓ Better performance",
    install_help_benefit_offline: "✓ Offline functionality",
    install_help_benefit_fullscreen: "✓ Full-screen interface",
    install_help_ios_step1: "1. Open Safari and navigate to the app",
    install_help_ios_step2: "2. Tap the Share button (square with arrow)",
    install_help_ios_step3: '3. Select "Add to Home Screen"',
    install_help_ios_step4: '4. Enter the app name and tap "Add"',
    install_help_android_step1: "1. Open Chrome and navigate to the app",
    install_help_android_step2: "2. Tap the menu (three dots) at the top right",
    install_help_android_step3: '3. Select "Install app"',
    install_help_android_step4: '4. Confirm by tapping "Install"',
    check_for_updates: "Check for updates",
    long_response_warning_title: "Warning: Long Response(s) Detected",
    long_response_warning_message: "The following responses exceed 50 characters and may be truncated on some displays:",
    long_response_warning_question: "Do you want to save the quiz anyway?",
    save_anyway: "Save Anyway",
    characters: "characters",
    usage_statistics: "Usage Statistics",
    recompute_minutes: "Recompute Monthly Total",
    tooltip_recompute_minutes: "Forces a fresh full computation from the Daily.co API and updates the stored value used in the next session report.",
    recompute_minutes_cached: "Cached total: {minutes} min.",
    recompute_minutes_result: "✓ {minutes} minutes this month (updated)",
    recompute_minutes_error: "✗ Failed – check your API key",
    floor_too_many_speakers: "Multiple participants are speaking. Please raise your hand to request the floor.",
    floor_granted: "You have been given the floor.",
    floor_denied_by_master: "Microphone is currently not permitted.",
    floor_revoked_by_master: "The host has muted your microphone.",
    floor_timeout: "Microphone activation request timed out.",
    give_floor: "Give floor",
    revoke_floor: "Revoke floor",
    speaking_allowed: "Speaking allowed",
    listening_only: "Listening only",
  },
};
